// Store side of the kitchen flow: which requests sit in the store's "To do".
import type { Requisition } from './types'

const FINISHED: Requisition['status'][] = ['draft', 'closed', 'rejected', 'cancelled']

/** Needs the store now: approve, issue, check a return — or deal with stock
 *  that went missing on the way. A missing-stock request stays in To do for
 *  everyone on the store side until it is written off or the stock turns up:
 *  an admin writes it off here; an inventory manager cannot, so the row says
 *  it needs a manager. Same rule as the badge
 *  (`store_todo` in GET /inventory-flow/requisitions/summary). */
export function storeNeedsAction(r: Requisition): boolean {
  if (FINISHED.includes(r.status)) return false
  if (r.has_shortage) return true
  if (r.kind === 'issue') return r.status === 'submitted' || r.status === 'approved' || r.status === 'partially_issued'
  return (r.status === 'issued' || r.status === 'received') && r.awaiting_receipt
}

